import React, { useState } from 'react'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { FaRegHeart } from "react-icons/fa6"
import './DigiHealthLandingNavbar.css'

const navLinksData = [
  { name: 'Home', href: 'home' },
  { name: 'About', href: 'about' },
  { name: 'Research', href: 'research' },
  { name: 'Collaboration', href: 'collaboration' },
  { name: 'Contact', href: 'contact' },
]

const DigiHealthLandingNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeLink, setActiveLink] = useState('home')

  const handleScroll = (targetId) => {
    const target = document.getElementById(targetId)
    if (target && ScrollSmoother.get()) {
      ScrollSmoother.get().scrollTo(target, true)
      setActiveLink(targetId)
      setMenuOpen(false)
    }
  }

  return (
    <nav className="Digi-Health-Landing-Navbar-Section-bg">
      <div className="Digi-Health-Landing-Navbar-Section-container">
        <div className="Digi-Health-Landing-Navbar-Section-logo">
          <span className="Digi-Health-Landing-Navbar-Section-logo-icon">
            <FaRegHeart />
          </span>
          <span>
            <span className="Digi-Health-Landing-Navbar-Section-logo-text-main">DigiHealth</span>
            <br />
            <span className="Digi-Health-Landing-Navbar-Section-logo-text-sub">India</span>
          </span>
        </div>

        <button
          className="Digi-Health-Landing-Navbar-Section-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`Digi-Health-Landing-Navbar-Section-links${menuOpen ? ' open' : ''}`}>
          <ul>
            {navLinksData.map(link => (
              <li key={link.name}>
                <button
                  onClick={() => handleScroll(link.href)}
                  className={`Digi-Health-Landing-Navbar-Section-link${activeLink === link.href ? ' active' : ''}`}
                >
                  {link.name}
                  {activeLink === link.href && <span className="Digi-Health-Landing-Navbar-Section-link-underline" />}
                </button>
              </li>
            ))}
          </ul>
          <a 
            target="_blank"
            rel="noopener noreferrer"
            href='mailto:info@digihealthindia.com' 
            className="Digi-Health-Landing-Navbar-Section-cta"
          >
            Join the Movement
          </a>
        </div>
      </div>
    </nav>
  )
}

export default DigiHealthLandingNavbar
